export default __webpack_public_path__ + "media/images/images/pages/fitness-slide-3-46fe71656e6c300f15d0fe3b6bdc35de.jpg";